import React, {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {ReactComponent as ArrowRightIcon} from "../../Setting/assets/icons/arrow-right.svg";
import {ReactComponent as PayWithCard} from "../assets/image/pay-with-card.svg";
import {ReactComponent as PayWithCash} from "../assets/image/pay-with-cash.svg";
import {Spinner} from "react-bootstrap";
import DiscountController from "../Controller/DiscountController";
import InvoiceState from "../interface/invoiceState";
import InvoiceInterface from "../interface/invoiceInterface";
import './../assets/css/SelectPaymentMethod.scss'
import {useTranslation} from "react-i18next";

export default function SelectPaymentMethod({data, setData, state, setState}: {
    data: InvoiceState,
    setData: React.Dispatch<React.SetStateAction<InvoiceState>>,
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t} = useTranslation();
    const {shopId} = useParams();
    const navigate = useNavigate();
    const desk = data.takeaway ? t("invoice.takeout") : data.deskActive?.label;
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string | null>(null);

    if (state.loading)
        return (
            <div className="select-payment-method-container">
                <div className={'loading'}>
                    <Spinner/>
                    <p>{selectedPaymentMethod === 'cash' ? t("invoice.waitingAlert") : t("invoice.paymentWaiting")}</p>
                </div>
            </div>
        );

    return (
        <div className="select-payment-method-container">
            <ArrowRightIcon onClick={() => new DiscountController(state, setState).backToInvoice()}/>
            <h3>{t("invoice.paymentMethod")}</h3>
            <div className="content">
                <div
                    onClick={() => {
                        setSelectedPaymentMethod('pos');
                        new DiscountController(state, setState).payment(shopId as string, navigate, desk, 'pos');
                    }}>
                    <PayWithCard/>
                    <h4>{t("invoice.payWithBankCard")}</h4>
                </div>
                <div
                    onClick={() => {
                        setSelectedPaymentMethod('cash');
                        new DiscountController(state, setState).payment(shopId as string, navigate, desk, 'cash');
                    }}>
                    <PayWithCash/>
                    <h4>{t("invoice.payWithCash")}</h4>
                </div>
            </div>
        </div>
    );
}
